import React from "react";
import {
	MdArticle,
	MdPerson,
	MdDashboard,
	MdImage,
	MdVideoLibrary,
	MdInfo,
	MdHome,
} from "react-icons/md";
import { RiImageCircleFill } from "react-icons/ri";
import { FaComments } from "react-icons/fa6";

const Dashboard = React.lazy(() => import("./views/admin/dashboard"));
const Beranda = React.lazy(() => import("./views/admin/beranda"));
const Carousel = React.lazy(() => import("./views/admin/carousel"));
const AddCarousel = React.lazy(
	() => import("./views/admin/carousel/components/AddCarousel")
);
const EditCarousel = React.lazy(
	() => import("./views/admin/carousel/components/EditCarousel")
);
const Posts = React.lazy(() => import("./views/admin/posts"));
const AddPost = React.lazy(
	() => import("./views/admin/posts/components/AddPosts")
);
const EditPost = React.lazy(
	() => import("./views/admin/posts/components/EditPosts")
);
const Categories = React.lazy(
	() => import("./views/admin/posts/categories")
);
const User = React.lazy(() => import("./views/admin/users"));
const AddUser = React.lazy(
	() => import("./views/admin/users/components/AddUser")
);
const EditUser = React.lazy(
	() => import("./views/admin/users/components/EditUser")
);
const Logo = React.lazy(() => import("./views/admin/logo"));
const AddLogo = React.lazy(
	() => import("./views/admin/logo/components/AddLogo")
);
const EditLogo = React.lazy(
	() => import("./views/admin/logo/components/EditLogo")
);
const Video = React.lazy(() => import("./views/admin/video"));
const AddVideo = React.lazy(
	() => import("./views/admin/video/components/AddVideo")
);
const EditVideo = React.lazy(
	() => import("./views/admin/video/components/EditVideo")
);
const Foto = React.lazy(() => import("./views/admin/foto"));
const AddFoto = React.lazy(
	() => import("./views/admin/foto/components/AddFoto")
);
const EditFoto = React.lazy(
	() => import("./views/admin/foto/components/EditFoto")
);
const Medsos = React.lazy(() => import("./views/admin/medsos"));
const Abouts = React.lazy(() => import("./views/admin/abouts"));

const routes = [];

const konten = [
	{
		name: "Dashboard",
		layout: "/admin",
		path: "dashboard",
		icon: <MdDashboard className="h-6 w-6" />,
		component: <Dashboard />,
	},
	{
		name: "Postingan",
		layout: "/admin",
		icon: <MdArticle className="h-6 w-6" />,
		path: "posts",
		component: <Posts />,
	},
	{
		name: "Tambah Postingan",
		layout: "/admin",
		path: "add-posts",
		hidden: true,
		component: <AddPost />,
	},
	{
		name: "Edit Postingan",
		layout: "/admin",
		path: "edit-posts/:id",
		hidden: true,
		component: <EditPost />,
	},
	{
		name: "Kategori Postingan",
		layout: "/admin",
		path: "categories",
		hidden: true,
		component: <Categories />,
	},
];

const beranda2 = [
	{
		name: "Beranda",
		layout: "/admin",
		path: "beranda",
		icon: <MdHome className="h-6 w-6" />,
		component: <Beranda />,
	},
	{
		name: "Carousel",
		layout: "/admin",
		path: "carousel",
		hidden: true,
		component: <Carousel />,
	},
	{
		name: "Tambah Carousel",
		layout: "/admin",
		path: "add-carousel",
		hidden: true,
		component: <AddCarousel />,
	},
	{
		name: "Edit Carousel",
		layout: "/admin",
		path: "edit-carousel/:id",
		hidden: true,
		component: <EditCarousel />,
	},
];

const tentang = [
	{
		name: "Tentang",
		layout: "/admin",
		path: "abouts",
		icon: <MdInfo className="h-6 w-6" />,
		component: <Abouts />,
	},
];

const media = [
	{
		name: "Galeri Foto",
		layout: "/admin",
		icon: <MdImage className="h-6 w-6" />,
		path: "foto",
		component: <Foto />,
	},
	{
		name: "Tambah Media Foto",
		layout: "/admin",
		path: "add-foto",
		hidden: true,
		component: <AddFoto />,
	},
	{
		name: "Edit Media Foto",
		layout: "/admin",
		path: "edit-foto/:id",
		hidden: true,
		component: <EditFoto />,
	},
	{
		name: "Galeri Video",
		layout: "/admin",
		icon: <MdVideoLibrary className="h-6 w-6" />,
		path: "video",
		component: <Video />,
	},
	{
		name: "Tambah Media Video",
		layout: "/admin",
		path: "add-video",
		hidden: true,
		component: <AddVideo />,
	},
	{
		name: "Edit Media Video",
		layout: "/admin",
		path: "edit-video/:id",
		hidden: true,
		component: <EditVideo />,
	},
];

const pengaturan = [
	{
		name: "User",
		layout: "/admin",
		path: "user",
		icon: <MdPerson className="h-6 w-6" />,
		component: <User />,
	},
	{
		name: "Tambah User",
		layout: "/admin",
		path: "add-user",
		hidden: true,
		component: <AddUser />,
	},
	{
		name: "Edit User",
		layout: "/admin",
		path: "edit-user/:id",
		hidden: true,
		component: <EditUser />,
	},
	{
		name: "Media Sosial",
		layout: "/admin",
		path: "medsos",
		icon: <FaComments className="h-6 w-6" />,
		component: <Medsos />,
	},
	{
		name: "Logo",
		layout: "/admin",
		path: "logo",
		icon: <RiImageCircleFill className="h-6 w-6" />,
		component: <Logo />,
	},
	{
		name: "Add Logo",
		layout: "/admin",
		path: "add-logo",
		hidden: true,
		component: <AddLogo />,
	},
	{
		name: "Edit Logo",
		layout: "/admin",
		path: "edit-logo/:id",
		hidden: true,
		component: <EditLogo />,
	},
];

export default routes;
export { konten };
export { beranda2 as beranda };
export { tentang };
export { media };
export { pengaturan };
